"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sex = exports.Sex = void 0;
const schema_1 = require("../schema");
var Sex;
(function (Sex) {
    Sex["Male"] = "MALE";
    Sex["Female"] = "FEMALE";
    Sex["Other"] = "OTHER";
})(Sex || (exports.Sex = Sex = {}));
exports.sex = schema_1.Schema.enum([
    Sex.Male,
    Sex.Female,
    Sex.Other
]).interpretation({ vocab: "snomed", code: "734000001" });
